<template>
  <div class="flex items-center">
    <input
      :id="id"
      class="form-radio h-4 w-4 border-gray-300 text-primary focus:ring-primary"
      type="radio"
      :value="value"
      :name="name"
      @change="updateInput"
      :checked="isChecked"
      :disabled="disabled"
    />
    <label class="ml-3 block text-sm text-gray-700" :for="id">
      <slot />
    </label>
  </div>
</template>

<script>
import { uniqueId } from "lodash";

export default {
  emits: ["update:modelValue"],
  props: {
    value: { type: [String, Number] },
    name: { type: String },
    modelValue: { default: "" },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      id: uniqueId("radio-"),
    };
  },
  computed: {
    isChecked() {
      return this.modelValue === this.value;
    },
  },
  methods: {
    updateInput() {
      this.$emit("update:modelValue", this.value);
    },
  },
};
</script>
